module.exports = __webpack_public_path__ + "static/media/Tacos de Pescado y Aderezo Verde.e51b0058.webp";